import { Component, Injectable, Input, OnChanges, OnInit } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { AlertService } from '../../../../../app/utils/alert.service';
import { BindComponentService } from "../../../../../app/utils/bind.component.service";
import { LoadingComponent } from "../../../../../app/home/paraEmpresas/modalLoading/content.component";
import { DataPackGroup } from '../../../../models/dataPackGroup.model';
import { ProcAsyncReportService } from '../../../../../app/services/reports.procasync.service';
import { ProcessAsyncReport } from '../../../../models/reports.process.asynchronous.model';


import * as _ from "lodash";
import * as moment from 'moment';
import { ReportsComponent } from '../content.component';

/**
 * @version $Id$
 */
@Component({
  selector: 'procAsyncReport',
  templateUrl: './content.template.html'
})
@Injectable()
export class ProcAsyncReportComponent implements OnInit, OnChanges {
  
  @Input() reportTypeName: any;
  @Input() refresh: number;

  procAsyncOperationsSummary: ProcessAsyncReport[] = [];

  constructor(private bindComponent: BindComponentService,
    private modalService: NgbModal,
    private procAsyncService: ProcAsyncReportService,
    private alertService: AlertService) {
  }

  ngOnInit() {
    this.loadViewProcAsync();
  }

  ngOnChanges() {
    //console.log('ngOnChanges - refresh:', this.refresh);
    this.loadViewProcAsync();
  }

  private loadViewProcAsync() {
    this.openModalLoading();
    this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
    this.procAsyncService.listProcAsyncOperations().subscribe(
      data => {
        const listaAgrupada: { [key: string]: ProcessAsyncReport } = {};

        this.procAsyncOperationsSummary = [];
        
        data.forEach(item=> {
          const key = `${item.id.transactionId}`;
          
          if (!listaAgrupada[key]) {
            listaAgrupada[key] = {
              requestedDate: item.requestedDate,
              processedDate: item.processedDate,
              operationType: this.getOperationType(item.id.operationId),
              countLines: 0,
              countSuccess: 0,
              countError: 0
            };
          }

          if (item.status === 'SUCCESS' ) {
            ++listaAgrupada[key].countSuccess;
          } else if(item.status === 'FAILED' || item.status === 'ERROR' ) {
            ++listaAgrupada[key].countError;
          }
          ++listaAgrupada[key].countLines;
        });

        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.procAsyncOperationsSummary = Object.keys(listaAgrupada).map(key => listaAgrupada[key]);
      },
      err => {
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modal-content-loading',
      size: 'lg',
    });
  }

  private getOperationType(operationString: string): string {
  switch (operationString) {
    case 'MOVE_LINES':
      return 'Movimentação de Linhas';
    case 'SAVE_LINES_DATA':
      return 'Atualização da Linha em dados';
    case 'SAVE_LINES_VOICE':
      return 'Atualização da Linha em voz';
    default:
      return 'Desconhecido';
  }
}

  private downloadFile(externalid : string){
    this.procAsyncService.generateReport(externalid, 1, 60000);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/reports/procasync/content.component.ts